module.exports = __webpack_public_path__ + "static/img/nodata-product.0ef1196.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product-detail/nodata-product.png
// module id = cw3k
// module chunks = 4